import GridTile from "../../grid/GridTile";
import MersenneTwister from "../../math/MersenneTwister";
import TileDecoratorTheme from "./TileDecoratorTheme";

export default class CavernDecorator {
    /**
     * 
     * @param {TileDecoratorTheme} ceilingDecoratorTheme
     * @param {TileDecoratorTheme} midDecoratorTheme
     * @param {TileDecoratorTheme} floorDecoratorTheme
     */
    constructor(ceilingDecoratorTheme, midDecoratorTheme, floorDecoratorTheme) {        

        /**
         * @constant
         * @type {TileDecoratorTheme}
         */
        this.ceilingDecoratorTheme = ceilingDecoratorTheme;
        /**
         * @constant
         * @type {TileDecoratorTheme}
         */
        this.midDecoratorTheme = midDecoratorTheme;
        /**
         * @constant
         * @type {TileDecoratorTheme}
         */
        this.floorDecoratorTheme = floorDecoratorTheme;
    }

    /**
     * Decorates the cavern tile with foliage and whatever.
     * @param {GridTile} tile 
     * @param {MersenneTwister} rng
     */
    decorateCavernTile(tile, rng) {
        const grid = tile.grid;

        const topNeighbor = tile.getNeighborTop();
        const bottomNeighbor = tile.getNeighborBottom();

        const ceilingTile = topNeighbor && !topNeighbor.open && grid === topNeighbor.grid; // tile just below ceiling
        const floorTile = bottomNeighbor && !bottomNeighbor.open && grid ===  bottomNeighbor.grid; // tile just above floor

        let fixtureDescription = null;
        if (ceilingTile && floorTile) {
            // If this cavern column is 1 tile in height, then maybe treat it like
            // a mid-column tile.
            if (this.midDecoratorTheme) {
                fixtureDescription = this.midDecoratorTheme.getFixtureDescription(rng);
            }
        }
        else if (ceilingTile) {
            if (this.ceilingDecoratorTheme) {
                fixtureDescription = this.ceilingDecoratorTheme.getFixtureDescription(rng);
            }
        }
        else if (floorTile) {
            if (this.floorDecoratorTheme) {
                fixtureDescription = this.floorDecoratorTheme.getFixtureDescription(rng);
            }
        }
        else if (this.midDecoratorTheme) {
            fixtureDescription = this.midDecoratorTheme.getFixtureDescription(rng); 
        }

        tile.fixtureDescription = fixtureDescription;
    }

}